module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('HalfCircleSpinner', {
    staticStyle: {
      "margin": "200px auto",
      "float": "none"
    },
    attrs: {
      "animation-duration": 2000,
      "size": 80,
      "color": '#ec4141'
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-006cdfce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loginLogout/redirecionar/RedirecionarAdministrativo.vue
// module id = 938
// module chunks = 1